import * as firebase from "firebase";
import * as firebaseui from "firebaseui";

const firebaseConfig = {
  apiKey: "AIzaSyBc_o_LItfGN3_n30eOSnWfr2mPhxloqIg",
  authDomain: "becreator-demo.firebaseapp.com",
  databaseURL: "https://becreator-demo.firebaseio.com",
  projectId: "becreator-demo",
  storageBucket: "becreator-demo.appspot.com",
  messagingSenderId: "472200528408",
  appId: "1:472200528408:web:430b1b1d2c81153aaff96d",
  measurementId: "G-EH47C0H0Y3"
};

const firebaseApp = !firebase.apps.length
  ? firebase.initializeApp(firebaseConfig)
  : firebase.app();

const firebaseAuthUI = () => {
  const uiConfig = {
    signInOptions: [
      firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      firebase.auth.FacebookAuthProvider.PROVIDER_ID,
      firebase.auth.TwitterAuthProvider.PROVIDER_ID
    ]
  };

  var ui = new firebaseui.auth.AuthUI(firebase.auth());
  ui.start("#firebaseui-auth-container", uiConfig);
};

export default firebaseApp;
export { firebaseAuthUI };
